import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import apix from '@/api.js'
import ixr from '@/components/navigation/ixrouter.js'
import snippets from '@/content/snippets'
import likeUtils from '@/utils/likes.js'
import axios from 'axios'
import urls from '@/data/urls.js'
import ids from 'uuid/v1'
import authAdmin from '@/auth-admin.js'
import langs from '@/langs.js'

let noStorage = false
try {
  window.localStorage['check'] = true
}
catch(err) {
  noStorage = true
  console.log('no local storage')
}

let vuexPersist = null
let vuexSession = null

let plugins = []

if(!noStorage) {
  vuexPersist = new VuexPersist({
    key: 'illustration-x',
    storage: localStorage,
    reducer: (state) => ({ likes: state.likes, profileFolder: state.profileFolder, azSortMode: state.azSortMode, editing: state.editing, 
      artistTestimonialState: state.artistTestimonialState, lang: state.lang, recentlyViewedArtists: state.recentlyViewedArtists,
      defaultGallery: state.defaultGallery, defaultAnimationGallery: state.defaultAnimationGallery, langPref: state.langPref,
      cookieWarning: state.cookieWarning, ilxvizid: state.ilxvizid, token: state.token
     })
  })
  
  vuexSession = new VuexPersist({
    key: 'illustration-x',
    storage: sessionStorage,
    reducer: (state) => ({ artists: state.artists, galleries: state.galleries, profile: state.profile, settings: state.settings, 
      poplangViewed: state.poplangViewed, ilxsesid: state.ilxsesid, utms: state.utms, referer: state.referer
    })
  })
  plugins.push(vuexPersist.plugin)
  plugins.push(vuexSession.plugin)
}


/*
function changeLanguage(lang) {
  lang = lang.toLowerCase()
  console.log('calling change language', lang)
  let obj = require('../data/i18n/' + lang + '.json')
  Object.assign(snippets, obj)
  snippets.loaded = true
}
*/

/*
async function changeLanguageAsync(lang) {
  lang = lang.toLowerCase()
  console.log('calling change language Async', lang)
  let fname = `${window.location.protocol}//${window.location.host}/i18n/${lang}.json`
  console.log('Downloading file from', fname)
  let res = await axios.get(fname)
  try {
    Object.assign(snippets, res.data)
    snippets.loaded = true
  }
  catch(err){
    console.log('changeLanguageErr', err)
  }
}
*/

let lastArtistFetch = 0

Vue.use(Vuex)

let loadingArtists = false
let loadingGalleries = false
const validLangs = ['UK','US','DE','BR','SX','FR','CN','AU','IN','SG']

export default new Vuex.Store({
  state: {
    token: null,
    user: null,
    artists: [],
    likes: [],
    profileFolder: 'default',
    profile: null,
    galleries: [],
    galleryData: {},
    lang: 'OO',
    azSortMode: 'random',
    azNewMode: false,
    azLocation: 'ZZ',
    message: {
      show: false,
      title: 'Illustration-x',
      message: ''
    },
    loginDialog: {
      show: false
    },
    devMessage: '',
    showHamburgerMenu: false,
    requestedScrollY: 0,
    pageLoaded: true,
    quote: {
      show: false,
      artist: 0,
      agent: null
    },
    admin: false,
    editor: false,
    editing: false,
    azimages: {},
    artistImages: {},
    artistAnimations: {},
    stopPreviews: false,
    newstags: null,
    artistTestimonialState: {},
    recentlyViewedArtists: [],
    signedInAdmin: false,
    adminToken: null,
    snippets:snippets,
    defaultGallery: null,
    defaultAnimationGallery: null,
    langPref: null,
    settings: null,
    cookieWarning: true,
    poplangViewed: [],
    ilxsesid: null,
    ilxvizid: null,
    utms: {},
    referer: null,
    fromPage: null,
    deferredPrompt: null,
    install: false,
    currentCategory: null,
    showTestimonialButton: false,
    popTesti: null,
    similars: null,
    showStylePopup: false,
    showingTabs: false,
    popSimilars: false,
    unpopSimilars: false
  },
  mutations: {
    setPopSimilars(state, val) {
      state.popSimilars = val
    },
    setUnpopSimilars(state, val) {
      state.unpopSimilars = val
    },
    setShowingTabs(state, val) {
      state.showingTabs = val
    },
    setShowStylePopup(state, val) {
      state.showStylePopup = val
    },
    setSimilars(state, val) {
      state.similars = val
    },
    setShowTestimonialButton(state, val) {
      state.showTestimonialButton = val
    },
    setPopTesti(state, val) {
      state.popTesti = val
    },
    setInstall(state, val) {
      state.install = val
    },
    setDeferredPrompt(state, val){
      state.deferredPrompt = val
    },
    setFromPage(state, val) {
      state.fromPage = val
    },
    setUtms (state, val) {
      state.utms = val
    },
    setReferer (state, val) {
      state.referer = val
    },
    setSessionId(state, val) {
      state.ilxsesid = val
    },
    setVisitorId(state, val) {
      state.ilxvizid = val
    },
    addPoplangView(state, val) {
      if(!state.poplangViewed.includes(val)) {
        state.poplangViewed.push(val)
      }
    },
    setCookieWarning(state, val) {
      state.cookieWarning = val
    },
    setSettings(state, val) {
      state.settings = val
    },
    setLangPref (state, pref) {
      if(pref){
        state.langPref = pref.toUpperCase()
      }
      else {
        state.langPref = pref
      }
    },
    setDefaultGallery (state, gallery_url) {
      state.defaultGallery = gallery_url
    },
    setDefaultAnimationGallery(state, gallery_url) {
      state.defaultAnimationGallery = gallery_url
    },
    // these have to become actions - maybe not, because we should not await the result
    addLike: function (state, id) {
      if(isNaN(id)) return
      let nid = Number(id)
      if(!state.likes.includes(nid)) {
        state.likes.push(Number(nid))
        if(state.token) {
          let folder = likeUtils.getCurrentFolder(state)
          folder.image_ids = state.likes.join(',')
          likeUtils.updateFolder(state, folder)
        }
      }
    },
    removeLike: function (state, id) {
      if(state.likes.includes(id)){
        let wh = state.likes.indexOf(id)
        state.likes.splice(wh, 1)
        if(state.token) {
          let folder = likeUtils.getCurrentFolder(state)
          folder.image_ids = state.likes.join(',')
          likeUtils.updateFolder(state, folder)
        }
      }
    },
    setProfileFolder(state, val) {
      state.profileFolder = val
      let f = likeUtils.getCurrentFolder(state)
      state.likes = likeUtils.stringToNumberArray(f.image_ids)
    },
    setFolder(state, val) {
      state.profileFolder = val.name
      state.likes = likeUtils.stringToNumberArray(val.image_ids)
    },
    setProfile(state, val) {
      state.profile = val
      if(val) {
        likeUtils.mergeLikes(state)
      }
    },
    addProfileFolder(state, val) {
      state.profileFolder = val
      state.likes = []
      likeUtils.getCurrentFolder(state)
      likeUtils.updateFolder(state, val)
    },
    removeProfileFolder(state, val) {
      console.log('removing', val)
      if(state.profile.folders < 2) {
        alert('Can\'t delete your last folder')
        return
      }

      state.profile.folders = state.profile.folders.filter(el => (el.name !== val))
      let fname = state.profile.folders[0].name
      state.profileFolder = fname
      let f = likeUtils.getCurrentFolder(state)
      state.likes = likeUtils.stringToNumberArray(f.image_ids)
      likeUtils.updateFolder(state, fname)
    },
    addRecent(state, val) {
      state.recentlyViewedArtists = state.recentlyViewedArtists.filter(el => el !== val)
      state.recentlyViewedArtists.unshift(val)
      if(state.recentlyViewedArtists.length > 30) {
        state.recentlyViewedArtists.pop()
      }
    },
    setLang(state, val) {
      if(!val) return
      val = val.toUpperCase()
      if((val !== state.lang)||(!snippets.loaded)) {
        if(validLangs.includes(val)){
          state.lang = val
          langs.changeLanguageAsync(val)
          state.snippets = snippets
          state.galleries = []
        }
      }
      
    },
    setAdminToken(state, val) {
      state.adminToken = val
    },
    setArtistTestimonialState(state, val) {
      state.artistTestimonialState[val.artist] = val.value
    },
    setNewsTags: function (state, val) {
      state.newstags = val
    },
    setStopPreviews: function (state, val) {
      state.stopPreviews = val
    },
    setEditing: function (state, val) {
      state.editing = val
    },
    setAzImages: function (state, val) {
      state.azimages[val.id] = val.data
    },
    setArtistImages: function (state, val) {
      state.artistImages[val.id] = val.data
    },
    setArtistAnimations: function (state, val) {
      state.artistAnimations[val.id] = val.data
    },
    setSignedInAdmin: function (state, signedIn) {
      state.signedInAdmin = signedIn
      state.editor = signedIn
      state.admin = signedIn
    },
    setUser: function (state, usr) {
      state.user = usr
    },
    setArtists: function (state, artists) {
      state.artists = artists
    },
    
    setGalleries: function (state, gals) {
      state.galleries = gals
    },
    setAzSortMode: function (state, mode) {
      state.azSortMode = mode
    },
    setMessage: function (state, info) {
      state.message.title = info.title
      state.message.message = info.message
      state.message.show = true
    },
    hideMessage: function (state) {
      state.message.show = false
    },
    showLogin: function (state) {
      state.loginDialog.show = true
    },
    hideLogin: function (state) {
      state.loginDialog.show = false
    },
    setDevMessage: function (state, message) {
      state.devMessage = message
    },
    setShowHamburgerMenu: function (state, show) {
      state.showHamburgerMenu = show
    },
    setAzNewMode: function (state, isnew) {
      state.azNewMode = isnew
    },
    setAzLocation: function (state, loc) {
      state.azLocation = loc
    },
    setRequestedScrollY: function (state, pos) {
      state.requestedScrollY = pos
    },
    setPageLoaded: function (state, val) {
      state.pageLoaded = val
    },
    setShowQuote: function (state, val) {
      if(val === true){
        state.quote.show = true
        return
      }
      if(val === false) {
        state.quote.show = false
        return
      }
      state.quote.artist = val.artist
      state.quote.agent = val.agent
      state.quote.show = true
    },
    setQuoteArtist: function (state, artist) {
      state.quote.artist = artist
    },
    clearQuoteItems: function(state) {
      console.log('called clearQuoteItems')
      state.quote.artist = null
      state.quote.agent = null
    },
    setToken: function (state, token ) {
      state.token = token
    },
    setUserData: function (state, session) {
      let tk = session.getIdToken()
      state.token = tk.getJwtToken()
      let payload = tk.decodePayload()
      let groups = payload['cognito:groups']
      if(groups) {
        state.admin = groups.includes('admin')
        state.editor = groups.includes('editor')
      }
    }
  },
  getters: {
    hasQuoteArtist: (state) => {
      return (!!state.quote.artist)
    },
    countSimilars: (state) => {
      if(!state.similars) {
        return 0
      }
      if(!state.similars.related){
        return 0
      }
      return state.similars.related.length
    },
    signedIn: (state) => {
      return state.token !== null
    },
    isNewsTranslatable: (state) => {
      return 'FR,CN,BR,SX'.includes(state.lang)
    },
    isNonEnglish: (state) => {
      return 'FR,CN,BR,SX'.includes(state.lang)
    },
    isNonUkPt: (state) => {
      return 'CN' === state.lang
    },
    sessionId: (state) => {
      if(state.ilxsesid === null) {
        state.ilxsesid = ids()
      }
      return state.ilxsesid
    },
    visitorId: (state) => {
      if(state.ilxvizid === null) {
        state.ilxvizid = ids()
      }
      return state.ilxvizid
    },
    recents: (state) => {
      return state.recentlyViewedArtists
    },
    getArtistTestimonialState: (state) => (artist) => {
      return state.artistTestimonialState[artist]
    },
    isLiked: (state) => (id) => {
      try{
        return state.likes.includes(id)
      }
      catch(err) {
        return false
      }
    },
    gallery: (state) => (id) => {
      return state.galleries.find(el => { return el.gallery_id == id} )
    },
    artistGalleries: (state) => (artist) => {
      let rets = state.galleries.filter(el => artist.galleries.includes(Number(el.gallery_id)))
      return rets
    },
    nonExcludedArtists: state => {
      let lang = state.lang.toLowerCase()
      return state.artists.filter(el => { return  !el.excludes.includes(lang) })
    },
    getMatchingArtist: (state) => (name) => {
      let res = state.artists.filter(el => { return (name.toLowerCase() === el.formatted_name.toLowerCase()) })
      if(res.length > 0){
        return res[0]
      }
      return null
    }
  },
  actions: {
    fetchSetting: async function (context, name) {
      if(context.state.settings === null) {
        try {
          let res = await axios.get(urls.imagebase + 'data/settings.json')
          context.commit('setSettings', res.data)
        }
        catch(err) {
          console.log('fetchSettings', err)
        }
      }
      return context.state.settings[name]
    },
    // you should make a copy of this
    fetchArtist: async function (context, name) {
      await context.dispatch('fetchArtists')
      name = name.toLowerCase()
      let artist = context.state.artists.find(el => el.portfolio_url.toLowerCase() === name)
      return artist
    },
    fetchArtistById: async function (context, id) {
      await context.dispatch('fetchArtists')
      let artist = context.state.artists.find(el => el.artist_id == id)
      return artist
    },
    fetchRecents: async function (context) {
      await context.dispatch('fetchArtists')
      let res = []
      for(var each of context.state.recentlyViewedArtists){
        let artist = context.state.artists.find(el => el.portfolio_url === each)
        res.push(artist)
      }
      return res
    },
    goRegion: function (context, region) {
      context.commit('setAzLocation', region)
      ixr.push('/illustrators')
    },
    waitForArtists: async function (context) {
      return new Promise((resolve, reject) => {
        setTimeout( () => {
          try {
            resolve(context.state.artists.length > 0)
          }
          catch(err) {
            reject(err)
          }
        }, 200)
      })
    },
    waitForGalleries: async function (context) {
      return new Promise((resolve, reject) => {
        setTimeout( () => {
          try {
            resolve(context.state.galleries.length > 0)
          }
          catch(err) {
            reject(err)
          }
        }, 200)
      })
    },
    refetchArtists: async function (context) {
      let n = new Date().getTime()
      if((lastArtistFetch === 0) || (n - lastArtistFetch > 10000))
      {
        console.log('refetching artists')
        let ret = await apix.get('collections/artists')
        for(let each of ret.data.artists) {
          each.rnd = Math.random() * 100
        }
        if(ret) {
          context.commit('setArtists', ret.data.artists)
          lastArtistFetch = new Date().getTime()
        }
      }
      else {
        console.log('not refetching, too recent')
      }
      return context.state.artists
    },
    fetchArtists: async function (context) {
      if(loadingArtists) {
        let res = false
        while(!res) {
          res = await context.dispatch('waitForArtists')
        } 
      }
      if(context.state.artists.length > 0) {
        return context.state.artists;
      }
      try {
        loadingArtists = true
        lastArtistFetch = new Date().getTime()
        let ret = await apix.get('collections/artists')
        for(let each of ret.data.artists) {
          each.rnd = Math.random() * 100
        }
        if(ret) {
          context.commit('setArtists', ret.data.artists)
          lastArtistFetch = new Date().getTime()
        }
        loadingArtists = false
      }
      catch(err) {
        console.error(err)
      }
      return context.state.artists
    },
    fetchGalleries: async function (context) {
      if(loadingGalleries) {
        let res = false
        while(!res) {
          res = await context.dispatch('waitForGalleries')
        } 
      }
      if(context.state.galleries.length > 0) {
        return context.state.galleries;
      }
      loadingGalleries = true
      try {
        let ret = await apix.post('collections/galleries', { lang: context.state.lang })
        if(ret) {
          context.commit('setGalleries', ret.data)
        }
        loadingGalleries = false
      }
      catch(err) {
        console.error(err)
      }
      return context.state.galleries
    },
    fetchGallery: async function (context, url) {
      let galleries = await context.dispatch('fetchGalleries')
      return galleries.find(el => ((el.url === url ) && (!el.redir)))
    },
    fetchGalleryData: async function (context, id) {
      let gd = context.state.galleryData[id]
      if(gd) {
        if(gd.length > 0){
          return context.state.galleryData[id]
        }
      }
      let res = await apix.get(`collections/gallery-data/${id}`)
      for(let each of res.data) {
        each.rnd = Math.random() * 100
      }
      context.state.galleryData[id] = res.data
      return res.data
    },
    updateProfile: async function (context) {
      let res = await apix.get('collections/user-data', { headers: {'Authorization': context.state.token } })
      if(res.data){
        context.commit('setProfile', res.data)
      }
    },
    
    checkUser: async function (context) {
      try {
        let adminsigned = await authAdmin.isSignedIn()
        context.commit('setSignedInAdmin', adminsigned)
      }
      catch(err) {
        console.log(err)
        context.commit('setSignedInAdmin', false)
      }
    },
    
    subscribe: async function (context, email) {
      let ret = await apix.post('subscriber/add', { lang: context.state.lang, email: email })
      console.log(ret)
    }
  },
  plugins: plugins
})
